<div class="content-msg type-b">
  <img src="./assets/img/icon_info_white.svg" alt="icon_info" />
  <p>Define con tu asesor el color que más te agrade. Las fotos aquí mostradas son de carácter demostrativo.</p>
</div>
